<template>
  <span class="text-red-500">*</span>
</template>

<script setup>
</script>